function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#00857C",
  fillRule: "nonzero"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M2.766 4h7.468a2 2 0 011.985 1.752L13 12H0l.781-6.248A2 2 0 012.766 4zm9.101 7l-.64-5.124A1 1 0 0010.234 5H2.766a1 1 0 00-.993.876L1.133 11h10.734z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M10 5V4c0-2.16-1.262-4-3.497-4C4.267 0 3 1.843 3 4v1h1V4c0-1.668.916-3 2.503-3C8.088 1 9 2.33 9 4v1h1z"
}));

var SvgCart = function SvgCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      viewBox: "0 0 13 12",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgCart, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/cart.84add8d9.svg";
export { ForwardRef as ReactComponent };